import { Attributes } from '@leverege/ui-attributes';
import AddressEditor from "./AddressEditor.js";
import VINEditor from "./VINEditor.js";
const builtIns = {
  address: AddressEditor,
  vin: VINEditor
};
export default {
  processBlueprints(molten, blueprints) {
    blueprints.forEach(blueprint => {
      const attributes = Attributes.getAttributesFor(blueprint.type);
      attributes.forEach(attribute => {
        const editor = attribute.source?.attribute?.getTagStartingWith('formEditor:', true);
        if (editor) {
          if (builtIns[editor]) {
            builtIns[editor].createFor(attribute.name, attribute.objectType, {
              molten
            });
          }
        }
      });
    });
  }
};